import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e33e85b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-10" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-form-label text-muted notes-caption" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-3 pl-0 pr-0"
}
const _hoisted_6 = ["maxlength"]

import { ref, computed, PropType} from 'vue';
import { useStore } from 'vuex';
import { Booking, Document } from '@/models';
import AuditlogsModal from '@/components/modals/AuditlogsModal.vue';
import Documents from '@/components/document/Documents.vue';
import OtherNotesDialog from "@/components/modals/OtherNotesDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingNotes',
  props: {
  field: {type: String as PropType<string>, default: ''},
  disabled: { type: Boolean as PropType<boolean>, required: false, default: false },
  documents: {type: Object as PropType<Document[]>, default: []},
  documentsfield: {type: String as PropType<string>, default: ''},
  fixedsize: { type: Boolean as PropType<boolean>, required: false, default: false },
},
  emits: ['showdocument'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props;

const store = useStore();
const showinput = ref(true);
const auditLogsModal = ref(null);
const accessissuesref = ref(null);
const othernotesModal = ref(null);
const booking = computed(() => store.getters['diary/booking']);
const notes = computed({
  get: () =>  {
    accessissuesref.value = booking.value[props.field as keyof Booking];
    return booking.value[props.field as keyof Booking];
  },
  set: (val) => {
    accessissuesref.value = val;
    store.commit('diary/setBookingDeep', { path: props.field, data: val });
  }
});

const getFieldDisplayName = () => Booking.getFieldDisplayName(props.field);

const getFieldCaption = () => Booking.getFieldCaption(props.field);
const showDocument = (index:number) => {
  emit('showdocument',index);
};
const accessissuesrowCount = computed(() => {
  if (!accessissuesref.value) return;
  return accessissuesref.value.scrollHeight > accessissuesref.value.clientHeight;
});
const showAccessIssuesnotesModal = () => {
  const modal = othernotesModal.value as any;
  modal.init(props);
  modal.show();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", {
            class: _normalizeClass(["col-form-label", { 'text-muted': __props.disabled }])
          }, _toDisplayString(getFieldDisplayName()) + " ", 3),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass({'col-md-9':__props.documentsfield, 'col-md-12':!__props.documentsfield})
            }, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(getFieldCaption()), 1)
            ], 2),
            (__props.documentsfield)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock(Documents, {
                    style: {"margin-top":"0px !important"},
                    buttontext: 'Document',
                    entity: 'booking',
                    key: __props.documents.length,
                    documents: __props.documents,
                    path: __props.documentsfield,
                    onClicked: showDocument
                  }, null, 8, ["documents", "path"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (notes.value || showinput.value)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            class: "form-control",
            rows: "3",
            ref_key: "accessissuesref",
            ref: accessissuesref,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notes).value = $event)),
            maxlength: __props.fixedsize ? 30 : null
          }, null, 8, _hoisted_6)), [
            [
              _vModelText,
              notes.value,
              void 0,
              { lazy: true }
            ]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("i", {
        class: "fas fa-arrow-down text-right ml-2",
        onClick: showAccessIssuesnotesModal,
        style: _normalizeStyle({ background: accessissuesrowCount.value ? 'yellow !important' : '' })
      }, null, 4),
      _createVNode(AuditlogsModal, {
        ref_key: "auditLogsModal",
        ref: auditLogsModal,
        field: __props.field
      }, null, 8, ["field"])
    ]),
    _createVNode(OtherNotesDialog, {
      name: `${__props.field}-modal`,
      field: __props.field,
      ref_key: "othernotesModal",
      ref: othernotesModal
    }, null, 8, ["name", "field"])
  ], 64))
}
}

})